import React, { useState } from 'react';
import CWHeader from '../components/cw/CWHeader';
import CWResources from '../components/cw/CWResources';
import PasswordGate from '../components/marketing/PasswordGate';
import '../cw.css';

const KEY = 'cw_marketing_unlocked';

export default function CWPage() {
  const [unlocked, setUnlocked] = useState(() => true);

  const unlock = () => {
    sessionStorage.setItem(KEY, '1');
    setUnlocked(true);
  };

  const lock = () => {
    sessionStorage.removeItem(KEY);
    setUnlocked(true);
  };

  return (
    <main className={`cw-page ${unlocked ? '' : 'cw-gate'}`}>
      <CWHeader />
      {unlocked ? <CWResources onLock={lock} /> : <PasswordGate onUnlock={unlock} />}
      {unlocked && <footer className="cw-footer">© 2026 Cartridge World</footer>}
    </main>
  );
}